"use strict";
exports.__esModule = true;
exports.getWidgetTypeLabel = exports.getDefaultOptions = exports.getDefaultStandingId = exports.getDefaultBaseUrl = exports.getSourceCode = void 0;
var tslib_1 = require("tslib");
var moment_1 = tslib_1.__importDefault(require("moment"));
var settings_1 = require("./settings");
exports.getSourceCode = function (elementId, baseUrl, options, widgetDeepLinks) {
    var urlParts = [baseUrl.endsWith('/') ? baseUrl.substring(-1) : baseUrl];
    var urlOptions = Object.entries(options || {}).reduce(function (acc, _a) {
        var opt = _a[0], value = _a[1];
        switch (opt) {
            case 'date': {
                acc.push('date', value);
                break;
            }
            case 'sportId': {
                acc.push('sel_sid', value);
                break;
            }
            case 'standingId': {
                acc.push('stid', value);
                break;
            }
        }
        return acc;
    }, []);
    urlParts.push.apply(urlParts, urlOptions);
    var mainScript = "<script id=\"enetpulse-mainscript-" + elementId + "\" type=\"text/javascript\" src=\"" + urlParts.join('/') + "\"></script>";
    if (widgetDeepLinks) {
        return "<script async type=\"text/javascript\">var wff_settings = " + JSON.stringify({
            settings: {
                "default": tslib_1.__assign({}, widgetDeepLinks)
            }
        }) + "</script>" + mainScript;
    }
    return mainScript;
};
exports.getDefaultBaseUrl = function (appSpace, widgetType) {
    var _a, _b, _c;
    if (!appSpace || !widgetType) {
        return '';
    }
    return ((_c = (_b = (_a = settings_1.DEFAULT_BASE_URL_CODE_BY_APPSPACE_AND_WIDGET_TYPE === null || settings_1.DEFAULT_BASE_URL_CODE_BY_APPSPACE_AND_WIDGET_TYPE === void 0 ? void 0 : settings_1.DEFAULT_BASE_URL_CODE_BY_APPSPACE_AND_WIDGET_TYPE[appSpace]) === null || _a === void 0 ? void 0 : _a[widgetType]) === null || _b === void 0 ? void 0 : _b.sourceCode) !== null && _c !== void 0 ? _c : '');
};
exports.getDefaultStandingId = function (appSpace) {
    if (appSpace === 'sportnet.sme.sk') {
        return 365723;
    }
    return undefined;
};
exports.getDefaultOptions = function (appSpace, widgetyType) {
    var ident = appSpace + ":" + widgetyType;
    switch (ident) {
        case 'sportnet.sme.sk:eventsCalendar': {
            return undefined;
        }
        case 'sportnet.sme.sk:livecenter': {
            return {
                date: moment_1["default"]().format('YYYY-MM-DD'),
                sportId: undefined
            };
        }
        case 'sportnet.sme.sk:medalTable': {
            return {
                standingId: '365723'
            };
        }
        default: {
            return undefined;
        }
    }
};
exports.getWidgetTypeLabel = function (widgetType) {
    var data = settings_1.ENETPULSE_WIDGET_TYPE_OPTIONS.find(function (opt) { return opt.value === widgetType; });
    return (data === null || data === void 0 ? void 0 : data.label) || '';
};
